export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_01.c68d901d.jpg";